<template>
    <CompanyBoxContent :title="$t('company.actualOwners') + ':'">
        <template v-if="downloadedOwners && !ownersEmpty" #data>
            <div class="table-responzive">
                <table class="table table-hover">
                    <thead class="table_head">
                        <tr>
                            <th>{{ $t("general.writeFirstName") }}</th>
                            <th>{{ $t("company.addressEstablishment") }}</th>
                            <th>{{ $t('company.owner') }} {{ $t('general.from') }}</th>
                            <th>{{ $t('company.owner') }} {{ $t("general.to") }}</th>
                        </tr>
                    </thead>
                    <tbody class="align-middle">
                        <!-- ACTUAL ACCOUNTS -->
                        <tr v-for="(owner, index) in owners" :key="index">
                            <td>
                                <span style="word-break: break-all;" v-if="owner.owner.jmeno && owner.owner.prijmeni">
                                    {{ owner.owner.jmeno }} {{ owner.owner.prijmeni }}
                                </span>
                            </td>
                            <td>
                                <span v-if="owner.owner.adresa.nazevObce">
                                    {{ owner.owner.adresa.nazevObce }}
                                </span>
                            </td>
                            <td>
                                <span v-if="owner.datumZapisu">
                                    <i18n-d tag="span" :value="new Date(owner.datumZapisu)"></i18n-d>
                                </span>
                            </td>
                            <td>
                                <span v-if="owner.datumVymazu">
                                    <i18n-d tag="span" :value="new Date(owner.datumVymazu)"></i18n-d>
                                </span>
                                <span v-else class="w-100">
                                    {{ $t('company.stillValid') }}
                                </span>
                            </td>
                        </tr>
                        <!-- OLD ACCOUNTS -->
                        <tr v-for="(oldOwner, index) in oldOwners" :key="index">
                            <td>
                                <span v-if="oldOwner.owner.jmeno && oldOwner.owner.prijmeni" class="w-100">
                                    {{ oldOwner.owner.jmeno }} {{ oldOwner.owner.prijmeni }}
                                </span>
                            </td>
                            <td>
                                <span v-if="oldOwner.owner.adresa.nazevObce" class="w-100">
                                    {{ oldOwner.owner.adresa.nazevObce }}
                                </span>
                            </td>
                            <td>
                                <span v-if="oldOwner.datumZapisu" class="w-100">
                                    <i18n-d tag="span" :value="new Date(oldOwner.datumZapisu)"></i18n-d>
                                </span>
                            </td>
                            <td>
                                <span v-if="oldOwner.datumVymazu" class="w-100">
                                    <i18n-d tag="span" :value="new Date(oldOwner.datumVymazu)"></i18n-d>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-if="downloadedOwners && ownersEmpty" #data>
            <div class="box">
                <p>{{ $t('company.noOwners') }}</p>
            </div>
        </template>
        <template v-if="!downloadedOwners" #data>
            <div class="box">
                <div class="row">
                    <div>
                        <span class="me-2">{{ $t('company.numberOfActiveOwners') }}:</span>
                        <span>{{ actualOWnersCount }}</span>
                    </div>
                    <div>
                        <span class="me-2">{{ $t('company.numberOfOldOwners') }}:</span>
                        <span>{{ oldOwnersCount }}</span>
                    </div>
                </div>
            </div>
            <div class="mt-3 d-flex justify-content-center" v-if="actualOWnersCount > 0 || oldOwnersCount > 0">
                <button class="btn btn_main d-flex align-items-center" data-bs-toggle="modal"
                    data-bs-target="#ownersGDPR">
                    <span>
                        {{ $t('company.showOwners') }}
                    </span>
                </button>
            </div>
        </template>
    </CompanyBoxContent>
    <Popup :header="$t('company.showOwners')" :editable="false" id="ownersGDPR" :showButton="true"
        @save-data="downloadOwners" :button="$t('company.showOwners')">
        <template v-slot:body>
            <div class="box">
                <p v-html="$t('company.GDPROwnersText')"></p>
            </div>
        </template>
    </Popup>
</template>

<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue";
import axios from "axios"
import Popup from "@/components/Popup.vue";

export default {
    props: {
        company: {
            type: Object,
            required: true
        },
        actualOWnersCount: {
            type: Number,
            required: true,
        },
        oldOwnersCount: {
            type: Number,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
        Popup
    },
    data() {
        return {
            owners: [],
            oldOwners: [],
            downloadedOwners: false,
            ownersEmpty: false
        }
    },
    methods: {
        downloadOwners: function () {
            if (this.company && this.company.organization_id) {
                axios.get("https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty-vr/" + this.company.organization_id).then(
                    function (response) {
                        const zaznamy = response.data.zaznamy[0];
                        const spolecnici = zaznamy.spolecnici;
                        if (spolecnici && spolecnici.length > 0) {
                            for (let i = 0; i < spolecnici.length; i++) {
                                const spolecnik = spolecnici[i].spolecnik;
                                if (spolecnik && spolecnik.length > 0) {
                                    for (let j = 0; j < spolecnik.length; j++) {
                                        const clen = spolecnik[j];

                                        // Get age if fyzickaOsoba exists
                                        let age = null;
                                        if (clen.fyzickaOsoba) {
                                            const birthDate = new Date(clen.fyzickaOsoba.datumNarozeni);
                                            const today = new Date();

                                            age = today.getFullYear() - birthDate.getFullYear();
                                            const monthDiff = today.getMonth() - birthDate.getMonth();
                                            const dayDiff = today.getDate() - birthDate.getDate();

                                            if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
                                                age--;
                                            }
                                        }
                                        // Push owner data to arrays
                                        if (clen.datumVymazu && clen.datumVymazu !== clen.datumVzniku) {
                                            this.oldOwners.push({
                                                owner: clen.osoba.fyzickaOsoba || clen.osoba.pravnickaOsoba,
                                                datumZapisu: clen.datumZapisu,
                                                datumVymazu: clen.datumVymazu || null,
                                                age: age ?? null
                                            })
                                            this.oldOwners.sort((a, b) => new Date(b.datumZapisu) - new Date(a.datumZapisu));
                                        } else {
                                            this.owners.push({
                                                owner: clen.osoba.fyzickaOsoba || clen.osoba.pravnickaOsoba,
                                                datumZapisu: clen.datumZapisu,
                                                age: age ?? null
                                            })
                                            this.owners.sort((a, b) => new Date(b.datumZapisu) - new Date(a.datumZapisu));

                                        }
                                        this.downloadedOwners = true;
                                    }
                                }
                            }
                        }
                        else {
                            this.ownersEmpty = true;
                            this.downloadedOwners = true;
                        }
                    }.bind(this)
                ).catch(() => {
                    this.ownersEmpty = true;
                    this.downloadedOwners = true;
                });
            }
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.title {
    padding: 0 0 5px 20px;

    h3 {
        font-weight: 700;
        font-size: 24px;
    }
}

.router_link {
    cursor: pointer;
    text-decoration: underline;
    color: $black;
}
</style>
